import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SHARED_IMPORTS } from './shared/shared-imports';
import { ApexOptions } from 'ng-apexcharts';
import { AppVersionCheckService } from './services/app-version/app-version-check.service'; 

// === START OF THE FIX: Using Partial<T> ===
declare global {
  interface Window {
    Apex: {
      chart: Partial<ApexOptions['chart']>;
      tooltip: Partial<ApexOptions['tooltip']>;
      dataLabels: Partial<ApexOptions['dataLabels']>;
      // === NEW: Add title property ===
      title: Partial<ApexOptions['title']>; 
      xaxis: Partial<ApexOptions['xaxis']>; 
      yaxis: Partial<ApexOptions['yaxis']>; 
      // ==============================
      [key: string]: any; 
    };
  }
}
// === END OF THE FIX ===

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SHARED_IMPORTS],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnDestroy,OnInit {
  private readonly appVersionCheck = inject(AppVersionCheckService);
  protected title = 'avyro-frontend-app';
  
  ngOnInit() { 
    this.setGlobalApexChartDefaults();
    this.appVersionCheck.start();
  }
  
private setGlobalApexChartDefaults(): void {
  
  if (typeof window.Apex !== 'undefined') {
    
    const globalFont = 'Roboto, Arial, sans-serif'; // Define the font once for consistency

    // 1. Set global font for the main chart area
    window.Apex.chart = {
      fontFamily: globalFont
    };

    // 2. Set font for the Chart Title (Fixes the current issue)
    window.Apex.title = {
      style: {
        fontFamily: globalFont
      }
    };
    
    // 3. Set font for tooltips
    window.Apex.tooltip = {
      style: {
        fontFamily: globalFont 
      }
    };
    
    // 4. Set font for data labels
    window.Apex.dataLabels = {
      style: {
        fontFamily: globalFont
      }
    };
    
    // **OPTIONAL BUT RECOMMENDED:** Set font for axis labels
    // X-axis (if used)
    window.Apex.xaxis = {
        labels: {
            style: {
                fontFamily: globalFont
            }
        }
    } as Partial<ApexOptions['xaxis']>;

    // Y-axis (if used)
    window.Apex.yaxis = {
        labels: {
            style: {
                fontFamily: globalFont
            }
        }
    } as Partial<ApexOptions['yaxis']>;

    // console.log('ApexCharts global font families set successfully, including the chart title.');
  }
}
  
  ngOnDestroy() {
    localStorage.clear();
  }
}